import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, Shuffle } from "lucide-react";
import api from "../../lib/api";
import { BACKDROPS, resetBackdropCache } from "../../lib/backdrops";

// Admin picker for the ballpark imagery used on personalized sessions (hero card, player, teaser).
export const BackdropPicker = () => {
  const [active, setActive] = useState("diamond-day");
  useEffect(() => { api.get("/admin/settings").then(({ data }) => setActive(data.backdrop || "diamond-day")); }, []);

  const choose = async (id) => {
    setActive(id);
    try {
      await api.post(`/admin/settings/backdrop?backdrop_id=${id}`);
      resetBackdropCache();
      toast.success(id === "rotate" ? "Backdrops now rotate per session" : "Backdrop updated");
    } catch (e) { toast.error("Could not save backdrop"); }
  };

  return (
    <div className="rounded-2xl bg-white border border-slate-200 p-4 mb-4" data-testid="admin-backdrop-picker">
      <div className="font-bold text-navy text-sm">Session backdrop</div>
      <div className="text-xs text-slate-500 mb-3">Pro-ballpark imagery shown on personalized visualizations.</div>
      <div className="grid grid-cols-3 gap-2">
        {BACKDROPS.map((b) => (
          <button key={b.id} data-testid={`backdrop-${b.id}`} onClick={() => choose(b.id)}
            className={`relative aspect-[4/3] rounded-xl overflow-hidden border-2 text-left ${active === b.id ? "border-royal" : "border-transparent"}`}>
            <img src={b.file} alt={b.label} className="absolute inset-0 w-full h-full object-cover" style={{ objectPosition: b.pos }} />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-navy/90 to-transparent p-1.5 text-[10px] font-semibold text-white leading-tight">{b.label}</div>
            {active === b.id && <span className="absolute top-1.5 right-1.5 w-5 h-5 rounded-full bg-royal text-white flex items-center justify-center"><Check size={12} /></span>}
          </button>
        ))}
        <button data-testid="backdrop-rotate" onClick={() => choose("rotate")}
          className={`aspect-[4/3] rounded-xl border-2 flex flex-col items-center justify-center gap-1 text-navy bg-slate-50 ${active === "rotate" ? "border-royal" : "border-slate-200"}`}>
          <Shuffle size={18} className="text-royal" />
          <span className="text-[10px] font-semibold">Rotate per session</span>
        </button>
      </div>
    </div>
  );
};

export default BackdropPicker;
